import { RacemapColors } from '@racemap/utilities/consts/common';
import { isTrackerOnline } from '@racemap/utilities/functions/trackers';
import type { TableCellProps } from 'react-virtualized';
import type { SetRequired } from 'type-fest';
import type {
  ManagedTracker,
  TrackerColumnKeys,
} from '../../../../store/trackers/trackers_reducers';
import { Columns } from '../../../DataTable';
import { MessageFilters } from '../../Filter/FilterTreeFunctions';

type MessageCounts = SetRequired<ManagedTracker, 'messagesCounts'>['messagesCounts'];
interface CellProps extends TableCellProps {
  cellData?: MessageCounts[
    | MessageFilters.WITH_ERROR_MESSAGES
    | MessageFilters.WITH_PENDING_MESSAGES
    | MessageFilters.WITH_SCHEDULED_MESSAGES];
  rowData: ManagedTracker;
}

interface Props {
  countType: 'errorCount' | 'pendingCount' | 'scheduledCount';
  colLabel: 'ERR' | 'PEN' | 'SCH';
  colTitle: 'Error messages' | 'Pending messages' | 'Scheduled messages';
  dataKey: TrackerColumnKeys.ERR | TrackerColumnKeys.PEN | TrackerColumnKeys.SCH;
  hint?: string;
}

export const MessagesCountColumn = ({ countType, colLabel, colTitle, dataKey, hint }: Props) => {
  const cellRenderer = ({ cellData, rowData }: CellProps) => {
    if (cellData == null) return <></>;
    const isConnected = isTrackerOnline(rowData.state);

    return getComponent(cellData, !!isConnected, countType);
  };

  return Columns.sortingColumn({
    dataKey,
    label: colLabel,
    headerTitle: colTitle,
    cellRenderer,
    minWidth: 55,
    maxWidth: 55,
    sortingMethod: (cellDataA: number, cellDataB: number) => cellDataB - cellDataA,
    hint,
  });
};

const getComponent = (
  count: number,
  isConnected: boolean,
  countType: 'errorCount' | 'pendingCount' | 'scheduledCount',
): React.ReactNode => {
  const notConnectColor = !isConnected
    ? RacemapColors.DarkGray
    : count > 0 && countType === MessageFilters.WITH_ERROR_MESSAGES
      ? RacemapColors.DarkRed
      : undefined;

  return (
    <div style={{ color: notConnectColor }}>
      <b>{count > 0 ? count : '-'}</b>
    </div>
  );
};
